import { ref, toRaw, useTemplateRef } from 'vue'

import type { Ref, ComputedRef, CSSProperties } from 'vue'
import type { SelectSearchOption, SelectSearchProps } from '../types/interfaces'

import { useDropdownPosition } from '../../composables/dropdown-position.hook'

interface SelectSearchOptions {
  props: SelectSearchProps
  onChange: (option: SelectSearchOption) => void
}

interface SelectSearchReturn {
  selectSearch: Readonly<Ref<HTMLElement | null>>
  refValue: Ref<SelectSearchOption | null>
  dropdownStyle: ComputedRef<CSSProperties | null>
  handleSelect: (option: SelectSearchOption) => void
  handleOpen: () => void
}

export const useSelectSearch = ({
  props,
  onChange,
}: SelectSearchOptions): SelectSearchReturn => {
  const selectSearch = useTemplateRef<HTMLElement>('selectSearch')

  const refValue = ref<SelectSearchOption | null>(props.value)

  const { dropdownStyle, setUpdateDropdownHeight } = useDropdownPosition({
    elementRef: selectSearch,
    isAvailablePosition: props.isAvailablePosition ?? false,
  })

  const handleSelect = (option: SelectSearchOption): void => {
    onChange(toRaw(option))
  }

  const handleOpen = (): void => {
    void setUpdateDropdownHeight()
  }

  return {
    selectSearch,
    refValue,
    dropdownStyle,
    handleSelect,
    handleOpen,
  }
}
